import { render, staticRenderFns } from "./points-reward-modal.vue?vue&type=template&id=2a8c2a50"
import script from "./points-reward-modal.vue?vue&type=script&lang=js"
export * from "./points-reward-modal.vue?vue&type=script&lang=js"
import style0 from "./points-reward-modal.vue?vue&type=style&index=0&id=2a8c2a50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports